import React, { useState } from "react";
import useStyles from "./styles";
import { Select } from "Components/Form";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import { SearchSelect } from "Components/Form/Input/SearchSelect";
import { SearchNormal1 } from "iconsax-react";
import { colors } from "@zapalacorp/tokens";
import RadioButton from "Components/Form/RadioGroup";
import SelectComponent from "Components/Form/SelectComponent/SelectComponent";
import SelectMultiple from "Components/Form/SelectMultiple";

export default function SelectSection() {
  const [selectedBranchesIdToAdd, setSelectedBranchesIdToAdd] = useState<number[]>([]);
  const [radioButton, setRadioButton] = useState("");
  const [selecteValue, setSelecteValue] = useState("");
  const [multipleSelecteValue, setMultipleSelecteValue] = useState<any[]>([]);

  const classes = useStyles();

  const branches = [
    { id: 1, name: "SearchSelect 1" },
    { id: 2, name: "SearchSelect 2" },
    { id: 3, name: "SearchSelect 3" },
    { id: 4, name: "SearchSelect 4" },
  ];

  const handleChangeBranchId = (id: string) => {
    const numericId = parseInt(id);
    setSelectedBranchesIdToAdd((prev) =>
      prev.includes(numericId) ? prev.filter((item) => item !== numericId) : [...prev, numericId]
    );
  };

  const handleSelectAllBranches = () => {
    const allIds = branches.map((b) => b.id);
    setSelectedBranchesIdToAdd(allIds);
  };

  const handleUnselectAllBranches = () => {
    setSelectedBranchesIdToAdd([]);
  };

  const selecteMultipleItems = [
    { key: "1", label: "Item 1" },
    { key: "2", label: "Item 2" },
    { key: "3", label: "Item 3" },
    { key: "4", label: "Item 4" },
  ];

  return (
    <>
      <div>
        <RadioButton
          label="RadioButton"
          required
          options={[
            {
              value: "1",
              label: "Option 1",
            },
            {
              value: "2",
              label: "Option 2",
            },
            {
              value: "3",
              label: "Option 3 (disabled)",
              disabled: true,
            },
          ]}
          value={radioButton}
          onChange={(e) => setRadioButton(e.target.value)}
          error={!radioButton}
          errorMessage="errorMessage"
        />
        <hr />
      </div>
      <div>
        <SearchSelect
          inputProps={{
            label: "SearchSelect",
            placeholder: "SearchSelect",
            required: true,
            leftIcon: <SearchNormal1 color={colors.gray500} />,
          }}
          items={
            branches?.map((branch) => ({
              value: branch.id ? String(branch.id) : "",
              label: branch.name ?? "",
              checked: selectedBranchesIdToAdd?.includes(branch.id),
            })) ?? []
          }
          handleChange={handleChangeBranchId}
          handleSelectAll={handleSelectAllBranches}
          handleUnselectAll={handleUnselectAllBranches}
          checkedCount={selectedBranchesIdToAdd?.length}
        />
        <hr />
      </div>
      <div>
        <Select
          label="Select"
          value={selecteValue}
          onChange={(event: SelectChangeEvent<any>) => {
            setSelecteValue(event.target.value as string);
          }}
          placeholder="Select"
          emptyPlaceholder="Empty select"
          required
          error={!selecteValue}
          errorMessage="errorMessage"
          infoMessage="infoMessage"
        >
          <MenuItem value="value1">value1</MenuItem>
          <MenuItem value="value2">value2</MenuItem>
          <MenuItem value="value3">value3</MenuItem>
          <MenuItem value="value4">value4</MenuItem>
        </Select>
        <hr />
      </div>
      <div>
        <SelectComponent
          label="SelectComponent"
          value={selecteValue}
          onChange={(event: SelectChangeEvent<any>) => {
            setSelecteValue(event.target.value as string);
          }}
          placeholder="SelectComponent"
          emptyPlaceholder="Empty SelectComponent"
          required
          error={!selecteValue}
          errorMessage="errorMessage"
          dataCy="order-status-select"
          infoMessage="infoMessage"
        >
          <MenuItem value="value1">value1</MenuItem>
          <MenuItem value="value2">value2</MenuItem>
          <MenuItem value="value3">value3</MenuItem>
          <MenuItem value="value4">value4</MenuItem>
        </SelectComponent>
        <hr />
      </div>
      <div>
        <SelectMultiple
          label="SelectMultiple"
          placeholder="SelectMultiple"
          dataCy="communication-channels"
          items={selecteMultipleItems}
          selecteds={multipleSelecteValue}
          value={multipleSelecteValue.map((item) => item.key)}
          onChange={(e) => {
            const selectedKeys = e.target.value as string[];

            const newSelecteds = selecteMultipleItems.filter((item) =>
              selectedKeys.includes(item.key)
            );
            setMultipleSelecteValue(newSelecteds);
          }}
          onAddAll={() => {
            setMultipleSelecteValue(selecteMultipleItems);
          }}
          onRemoveAll={() => {
            setMultipleSelecteValue([]);
          }}
          renderInternalCount
        />
        <hr />
      </div>
    </>
  );
}
